import styled from "styled-components";

export const PromptConfigurationContainer = styled.div`
  height: 100%;
  width: 95%;
  display: flex;
  flex-direction: column;
  gap: 24px;  
  padding-top:1%;  
`;

export const PromptConfigurationFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;  
  align-items: center;
  gap: 4px;
`;

export const ConfigForm = styled.form`
  display:flex;
  flex-direction: column;
  gap: 16px;  
    
   & > div:nth-child(2){
      height: 145px; 
   } 
`;